import { FirebaseApp, initializeApp } from 'firebase/app'
import { browserLocalPersistence, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth'
import firebaseConfig from '#/configs/firebase'

export const firebaseApp = initializeApp(firebaseConfig)
export const getAuth = (app: FirebaseApp) =>
  initializeAuth(app, { persistence: [indexedDBLocalPersistence, browserLocalPersistence] })
